"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Caracteristica = void 0;
var Caracteristica = /** @class */ (function () {
    function Caracteristica(_a) {
        var _b = _a._id, _id = _b === void 0 ? '' : _b, _c = _a.DS_CARACT, DS_CARACT = _c === void 0 ? '' : _c, _d = _a.CARACT_VALOR, CARACT_VALOR = _d === void 0 ? new Array() : _d;
        this._id = _id;
        this.DS_CARACT = DS_CARACT;
        this.CARACT_VALOR = CARACT_VALOR;
    }
    return Caracteristica;
}());
exports.Caracteristica = Caracteristica;
//# sourceMappingURL=Caracteristica.js.map